import { EN_TENANT_NAME } from '../../enums/tenant';
import { registerPlugin } from '../../plugins/plugin_register';
import { DefaultRegistry } from '../default_registry';
import { registerTenantConfig } from '../register';

@registerTenantConfig(EN_TENANT_NAME.bozhong)
export class BozhongTenantRegistry extends DefaultRegistry {
  static async register(): Promise<void> {
    // super.register();
    const { ProjectionSettingReplenisherBozhong } = await import(
      '../../plugins/service_plugins/projection_setting_replenisher/projection_setting_replenisher_bozhong'
    );
    registerPlugin(ProjectionSettingReplenisherBozhong);

    const { UIConfigBozhong } = await import(
      '../../plugins/service_plugins/ui_config/ui_config_bozhong'
    );
    registerPlugin(UIConfigBozhong);

  }
}
